import React from "react";
import { PeekDivider, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { StepIndicator } from "@components/common";
import { NewReportBackButton } from "./new-report-back-button";
import { NewReportHelpButton } from "./new-report-help-button";
import { NewReportNextButton } from "./new-report-next-button";
export const NewReportLayout = ({ steps, activeStep, title, subtitle, children, nextLabel, nextDisabled = false, nextAboveContent, onNext, onBack, onHelp, }) => {
    return (React.createElement(PeekStack, { width: "100%", height: "100dvh", direction: "column", sx: { overflow: "hidden" } },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { px: 4, pt: 3, pb: 1, flexShrink: 0 } },
            React.createElement(NewReportBackButton, { onClick: onBack }),
            React.createElement(StepIndicator, { steps: steps, activeStep: activeStep, sx: { width: "60%" } }),
            React.createElement(NewReportHelpButton, { onClick: onHelp })),
        React.createElement(PeekStack, { direction: "column", alignItems: "center", justifyContent: "center", gap: "5vh", sx: { flex: 1, minHeight: 0, overflowY: "auto" } },
            React.createElement(PeekStack, { spacing: 1, alignItems: "center", textAlign: "center" },
                React.createElement(PeekTypography, { variant: "h1" }, title),
                React.createElement(PeekTypography, { variant: "h4", color: "info.main" }, subtitle)),
            children),
        React.createElement(PeekStack, { sx: { flexShrink: 0 } },
            React.createElement(PeekDivider, { light: true }),
            React.createElement(PeekStack, { alignItems: "center", gap: 1, sx: { px: 4, py: 4 } },
                nextAboveContent,
                React.createElement(NewReportNextButton, { label: nextLabel, disabled: nextDisabled, onClick: onNext })))));
};
export default NewReportLayout;
